import { TodoDescriptorType, TodoDescriptor } from 'owa-todo-cache';
import { assertNever } from 'owa-assert';
import { today } from 'owa-datetime';
import { isTodoFolderList, isTodoMyDayList, TodoListIdType, TodoListId } from 'owa-todo-list-types';
import { OrderByValue } from 'owa-todo-service';

const MAX_RECENTLY_COMPLETED_TASKS = 5;
export function getDescriptorForListId(id: TodoListId, isComplete: boolean): TodoDescriptor {
    const listId: TodoListId = id ? id : { Id: null, type: TodoListIdType.Folder };
    const maxCount = isComplete ? MAX_RECENTLY_COMPLETED_TASKS : undefined;

    if (isTodoMyDayList(listId)) {
        return {
            type: TodoDescriptorType.MyDay,
            date: today(),
            isComplete: isComplete,
            maxCount: maxCount,
            orderBy: isComplete ? OrderByValue.CompletedDateTime : OrderByValue.CommittedOrder,
        };
    } else if (isTodoFolderList(listId)) {
        return {
            type: TodoDescriptorType.FolderId,
            folderId: listId.Id,
            isComplete: isComplete,
            maxCount: maxCount,
            orderBy: isComplete ? OrderByValue.CompletedDateTime : OrderByValue.OrderDateTime,
        };
    }
    return assertNever(listId);
}
